// Show thumb video on img hover
(function () {
    const $grid_item = $('.js-c-grid-item .c-grid-ratio');
    if (!$grid_item.length) return false;

    /**
     * Thumb item
     */
    class Thumb {
        /**
         * @param {jQuery} $item
         */
        constructor($item) {
            this.$item = $item;
            this.$parent = $item.parents('.js-c-grid-item');
            this.$img = $item.find('img[data-videosrc]');
            this.video_type = this.$img.attr('data-videotype') || false;
            this.video_src = this.$img.attr('data-videosrc') || false;
            this.$badges = $('.js-c-grid-badges', this.$parent);
            this.$video = null;
            this.playing = false;
            this.loaded = false;
            this.$flag = null;

            if (this.video_type && this.video_src && !this.$item.parents('.owl-item').length) {
                this.init();
            }
        }

        init() {
            this.$flag = $('<span class="c-grid-video--availible u-block u-absolute u-pos--l u-pos--t u-disabled u-z--neg u-visibility--hidden" /><span class="c-grid-video--progress u-absolute u-pos--l u-width--zero" />');

            this.$item.append(this.$flag);

            this.$item.add(this.$badges)
                .on('mouseenter touchstart', () => {
                    $grid_item.not(this.$item).removeClass('hovered');

                    $("video", $grid_item).each(function () {
                        $(this).get(0).pause();
                    });

                    if (!this.$flag.is(':visible')) return false;
                    this.$item.addClass('hovered');
                    if (this.loaded) this.play(); else this.load();
                })
                .on('mouseleave', () => {
                    this.$item.removeClass('hovered');
                    if (!this.$flag.is(':visible')) return false;
                    if (this.playing) this.stop();
                });
        }

        load() {
            this.$video = $('<video loop playsinline muted class="u-absolute u-stretch u-block u-c u-transition--video u-z--zero u-height--full u-width--full u-scale--video"><source src="' + this.video_src + '" type="' + this.video_type + '"></video>');

            this.$img.after(this.$video);
            this.loaded = true;

            this.$video
                .on('play', () => {
                    this.playing = true
                })
                .on('pause', () => {
                    this.playing = false
                })
                .on('canplaythrough', () => {
                    if (!this.playing) {
                        this.play()
                    }
                });

            this.play();
        }

        play() {
            this.$video.get(0).playbackRate = 1.2;
            this.$video.get(0).play();
            this.playing = true;
        }

        stop() {
            this.$video.get(0).pause();
            this.playing = false;
        }
    }

    let timer;

    // Create new Thumb item on hover
    $grid_item
        .on('mouseenter.init touchstart.init', function () {
            // wait to prevent miss hover
            timer = setTimeout(() => {
                clearTimeout(timer);
                new Thumb($(this));

                $(this).off('mouseenter.init');
                $(this).off('touchstart.init');
                $(this).off('mouseleave.init');
                $(this).trigger('mouseenter');
            }, 400);
        })
        .on('mouseleave.init', function () {
            clearTimeout(timer);
        })

})();
